<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a button that will display a popup that can run different scripts based on answer
    *
    * @since 20200716
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <span>
        <div class="modal fade" :id="'question_confirm_modal_' + the_id" role="dialog">
            <div class="modal-dialog modal-lg">       
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{title}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        {{text}}
                    </div>
                    <div class="modal-footer">
                        <button v-for="but in buttons" :key="but.name" type="button" @click="evaluateScript(but.script)" :class="but.class">{{but.name}}</button>
                    </div>
                </div>
            </div>
        </div>
        <button type="button" data-toggle="modal" :data-target="'#question_confirm_modal_' + the_id" :class="buttonClass"><span v-html="buttonText"></span></button>
    </span>
</template>

<script>
    //stores a counter of ids so that each popup has a unique id for reference
    export const store = {
        state: 1,
        increment() {
            ++this.state
        }
    };
    export default{
        props: {
            //the title to be displayed on the popup
            title: {
                type: String,
                default: 'Question'
            },
            //the text to be displayed on the popup
            text: {
                type: String,
                default: ''
            },
            //the text to be displayed on the button
            buttonText: {
                type: String,
                default: 'Save'
            },
            //an array of buttons
            buttons: {
                type: Array
            },
            //the classes to put in the button
            buttonClass: {
                type: Array
            },
        },
        mounted() {
            this.the_id = store.state;
            store.increment();
        },
        data() {
            return {
                // the unique id
                the_id: 1
            }
        },
        methods: {
            /**
             * Evalauates and runs the provided javascript
             * 
             * @param string script the script to run
             */
            evaluateScript: function(script) {
                eval(script)
            }
        }
    }
</script>